import React from 'react';
import { BrowserRouter as Router, Navigate, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import SubmitBug from './pages/SubmitBug';
import TrackBugs from './pages/TrackBugs';
import UserAuth from './pages/UserAuth';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import PublicNoticeDetail from './pages/PublicNoticeDetail';
import PublicNotices from './pages/PublicNotices';
import './App.css';
import { getAppBasePath } from './appPaths';

function UserRoute({ children }) {
    const location = useLocation();
    const isLoggedIn = Boolean(localStorage.getItem('userToken'));

    return isLoggedIn
        ? children
        : <Navigate to="/login" replace state={{ from: location.pathname }} />;
}

function App() {
    return (
        <Router basename={getAppBasePath()}>
            <div className="app">
                <Header />
                <main className="main-content">
                    <Routes>
                        <Route path="/" element={<SubmitBug />} />
                        <Route path="/track" element={<TrackBugs />} />
                        <Route path="/notices" element={<UserRoute><PublicNotices /></UserRoute>} />
                        <Route path="/notices/:ticketId" element={<UserRoute><PublicNoticeDetail /></UserRoute>} />
                        <Route path="/login" element={<UserAuth />} />
                        <Route path="/admin" element={<AdminLogin />} />
                        <Route path="/admin/dashboard" element={<AdminDashboard />} />
                    </Routes>
                </main>
                <Footer />
            </div>
        </Router>
    );
}

export default App;
